import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analytics } from '../firebaseConfig';
import { logEvent } from 'firebase/analytics';
import { isCodexUi } from '../utils/codexEnv';

export const useAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    if (isCodexUi || !analytics) {
      return;
    }
    // Log page view
    logEvent(analytics, 'page_view', {
      page_path: location.pathname,
      page_title: document.title
    });
  }, [location]);
}; 
